module.exports = __webpack_public_path__ + "static/media/PedalaManderal.0ce5c1d3.jpeg";